module.exports = __webpack_public_path__ + "static/the-social-animal-db09ce27e9670ef9b69bf0a5545406d8.jpg";